<template>
  <div class="page-wrap">
    <oHead></oHead>
    <animationWrap style="top: 0" @current="(newV)=>{this.currentModule = newV}">
      <swiper :options="swiperOption" ref="mySwiper" class="banner-swiper" @mouseenter.native="swiperEnter('mySwiper')" @mouseleave.native="swiperLeave('mySwiper')">
        <swiper-slide class="swiper-item" v-for="(item,ind) of swiperList" :key="ind">
          <div class="swiper-img" :style="{backgroundImage: `url(${item.imgUrl})`}">
            <Transition
              enter-active-class="animate__animated animate__bounceInDown"
            >
              <div class="content" v-if="currentModule > 0">
                <div class="title">{{item.title}}</div>
                <div class="line"></div>
                <div class="desc">{{item.desc}}</div>
                <div class="w-btn" @click="consultVisible = true">产品咨询</div>
              </div>
            </Transition>
          </div>
        </swiper-slide>
      </swiper>
      <moduleWrap
        :active="currentModule>0"
        title="<span style='margin-right: 20px'>汇聚万福</span><span>智赢未来</span>"
        bgCol="#f7fafc"
        subTitle="<span style='margin-right: 10px'>赋能环保水利</span><span>引领数智创新</span>"
      >
        <div class="intro-slot">
          <Transition
            enter-active-class="animate__animated animate__bounce"
          >
            <img v-if="currentModule>0" width="278" height="300" src="/img/img_photo.png" alt />
          </Transition>
          <Transition
            enter-active-class="animate__animated animate__bounce"
          >
            <div class="intro-text" v-if="currentModule>0">
              <div class="intro-top">
                <div class="intro-title">公司介绍</div>
                <div class="intro-more" @click="$router.push({ path: '/aboutUs' })">
                  查看更多
                  <i class="iconfont a-Icon_arrow-right"></i>
                </div>
              </div>
              <div
                class="intro-bottom"
              ><p>福建万福信息技术有限公司（以下简称“万福信息”）成立于2017年，公司总部位于福州市高新区万福中心。万福信息致力于环保、水利等行业的数字化转型和提升，2021年1月获南威软件（股票代码：603636）战略投资。万福信息以AI行业应用为锚点，以环保、水利业务场景为驱动，力求贴近、再贴近客户需求，构建AI体系化、场景化能力，实现技术和业务的有机融合。</p></div>
            </div>
          </Transition>
        </div>
      </moduleWrap>
      <moduleWrap
        ref="solutionModule"
        :active="currentModule>1"
        title="聚集4大场景，围绕视觉AI，构建3大能力"
        bgImg="/img/bg01.png"
        subTitle="<span style='margin-right: 10px'>赋能环保水利</span><span>引领数智创新</span>"
      >
        <div class="solution-slot">
          <Transition
            enter-active-class="animate__animated animate__bounceInLeft"
          >
            <ul class="solution-menu" v-if="currentModule>1">
              <li
                v-for="(item,ind) in solutionData"
                :key="ind"
                :class="{active:ind == solutionActive}"
                @mouseleave.stop="tabLeave"
                @mouseenter.stop="solutionEnter(ind)"
              >{{item.name}}</li>
              <li class="line" :style="{top:solutionActive*80+32+'px'}"></li>
            </ul>
          </Transition>
          <Transition
            enter-active-class="animate__animated animate__bounceInRight"
          >
            <div v-if="currentModule>1" class="solution-content">
              <div
                class="solution-item"
                :style="solutionItemSty(i)"
                v-for="(solution, i) in solutionData[solutionActive].children"
                :key="i"
              >
                <div class="item-name">{{solution.name}}</div>
                <div class="item-content">{{solution.content}}</div>
                <div class="item-btn" @click.stop="jumpTo(solution)">
                  查看详情
                  <i class="iconfont arrowright"></i>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </moduleWrap>
      <moduleWrap
        :active="currentModule>2"
        title="万福信息核心能力"
        titCol="#fff"
        subCol="#929caa"
        bgImg="/img/bg03.png"
        subTitle="<span style='margin-right: 10px'>赋能环保水利</span><span>引领数智创新</span>"
      >
        <div class="matrix-slot">
          <Transition
            enter-active-class="animate__animated animate__bounceInRight"
          >
            <div class="matrix-wrap" v-if="currentModule>2">
              <div class="matrix-item" v-for="(matrix,index) in matrixData" :key="index">
                  <div
                    class="matrix-title"
                    :style="{backgroundImage: `url(${matrix.imgUrl})`}"
                  >{{matrix.name}}</div>
                  <div class="item-name" @click.stop="jumpTo(item)" v-for="(item,ind) in matrix.children" :key="ind">
                    <span v-html="item.name"></span>
                  </div>
                </div>
            </div>
          </Transition>

        </div>
      </moduleWrap>

      <moduleWrap
        :active="currentModule>2"
        title="硬件产品"
        class="hardware-wrap"
        titCol="#333333"
        subCol="#929caa"
        bgImg="/img/bg06.png"
        subTitle="<span style='margin-right: 10px'>赋能环保水利</span><span>引领数智创新</span>"
      >
        <div class="hardware-slot">
          
          <swiper class="hardware-swiper" 
            @mouseenter.native="swiperEnter('hardwareSwiper')" @mouseleave.native="swiperLeave('hardwareSwiper')"
            :options="hardwareOption" ref="hardwareSwiper">
              <swiper-slide v-for="(item,ind) of hardwareData" :key="ind">
                <Transition enter-active-class="animate__animated animate__rubberBand">
                  <div class="hardware-item" v-if="currentModule > 2">
                    <div class="hardware-img" :style="{backgroundImage: `url(${item.imgUrl})`}"></div>
                    <div class="hardware-bottom">
                      <div class="title" :title="item.name">{{item.name}}</div>
                      <div class="desc" :title="item.content">{{item.content}}</div>
                      <div class="item-btn" @click.stop="jumpTo(item)">
                        查看详情
                        <i class="iconfont arrowright"></i>
                      </div>
                    </div>
                  </div>
                </Transition>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>

        </div>
      </moduleWrap>

      <moduleWrap title="近期精彩案例" class="case-wrap" :active="currentModule>3" bgCol="#f7fafc">
        <div class="case-slot">
          <Transition
            enter-active-class="animate__animated animate__bounceInLeft"
          >
          <div class="case-menu" v-if="currentModule>3">
            <div
              class="case-tab"
              v-for="(cases,index) in caseData"
              :key="index"
              :class="{active: casesIndex == index}"
              @mouseleave.stop="tabLeave"
              @mouseenter.stop="caseEnter(index)"
            >{{cases.name}}</div>
            <i class="line" :style="{left: 120 + casesIndex*240+'px'}"></i>
          </div>
          </Transition>
          <Transition
            enter-active-class="animate__animated animate__bounceInRight"
          >
            <div class="target-content" v-if="currentModule>3">
              <div
                class="case-item"
                :style="{backgroundImage: `url(${item.imgUrl})`}"
                v-for="(item,ind) in caseData[casesIndex].children"
                :key="ind"
              >
                <div class="case-name" :title="item.name">{{item.name}}</div>
                <div class="case-content" :title="item.content">{{item.content}}</div>
                <div class="item-btn" @click.stop="jumpTo(item)">
                  查看详情
                  <i class="iconfont arrowright"></i>
                </div>
              </div>
            </div>
          </Transition>


        </div>
      </moduleWrap>
      <moduleWrap
        :active="currentModule>4"
        title="安全可信 快捷部署"
        titCol="#fff"
        subCol="#929caa"
        bgImg="/img/bg04.png"
        subTitle="500+客户选择与万福同行"
      >
        <div class="deploy-slot">
          <Transition
            enter-active-class="animate__animated animate__bounceInRight"
          >
            <div class="deploy-wrap" v-if="currentModule>4">
              <div class="deploy-item" v-for="(item,index) in deployData" :key="index">
                <div class="item-top">{{(item.name).toFixed(0)+item.unit}}</div>
                <div class="item-bottom">{{item.content}}</div>
              </div>
            </div>
          </Transition>


        </div>
      </moduleWrap>
      <!-- <moduleWrap
        :active="currentModule>5"
        title="新闻资讯"
        bgCol="#f7fafc"
        subTitle="赋能智慧产业，让数据创造更大价值"
      >
        <div class="news-slot">
          <Transition
            enter-active-class="animate__animated animate__bounceInLeft"
          >
           <div class="news-left" v-if="currentModule>5">
            <div class="news-img" :style="{backgroundImage: `url(${newsData[0].imgUrl})`}"></div>
            <div class="left-content">
              <div class="con-top">{{newsData[0].name}}</div>
              <div class="content" v-html="newsData[0].content"></div>
              <div class="con-bottom">
                <span>{{newsData[0].date}}</span>
                <div class="item-btn" @click.stop="jumpTo(newsData[0])">
                  查看详情
                  <i class="iconfont arrowright"></i>
                </div>
              </div>
            </div>
          </div>
          </Transition>
          <Transition
            enter-active-class="animate__animated animate__bounceInRight"
          >
          <div class="news-right" v-if="currentModule>5">
            <div class="news-item" v-for="(news, ind) in newsData.slice(1)" :key="ind">
              <div class="item-left">
                <div class="left-wrap">
                  <div
                    class="left-top"
                  >{{new Date(news.date).getFullYear()+'.'+(new Date(news.date).getMonth()+1)}}</div>
                  <div class="left-bottom">{{new Date(news.date).getDate()}}</div>
                </div>
              </div>
              <div class="item-right">
                <div class="con-top">{{news.name}}</div>
                <div class="content">{{news.content}}</div>
                <span class="item-btn" @click.stop="jumpTo(news)">
                  查看详情
                  <i class="iconfont arrowright"></i>
                </span>
              </div>
            </div>
          </div>
          </Transition>


        </div>
      </moduleWrap> -->
      <oFoot :active="currentModule>5"></oFoot>
    </animationWrap>
    <Transition enter-active-class="animate__animated animate__pulse" leave-active-class="animate__animated animate__fadeOut">
      <consulting v-if="consultVisible" :dialog="true" @close="consultVisible=false"></consulting>
    </Transition>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import consulting from '@/components/consulting.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import moduleWrap from '@/components/moduleWrap.vue'
import oHead from '@/components/header.vue'
import oFoot from '@/components/footer.vue'
import animationWrap from '@/components/animationWrap.vue'
import { jumpTo,tabLeave,swiperEnter,swiperLeave } from '@/util.js'
import gsap from 'gsap'

export default {
  components: {
    consulting,
    swiper,
    oHead,
    swiperSlide,
    moduleWrap,
    oFoot,
    animationWrap
  },
  data() {
    return {
      consultVisible: false,
      currentModule: 0,
      // banner
      swiperList: [
        {
          imgUrl: '/img/banner01@2x.png',
          title: '汇聚万福  智赢未来',
          desc: '万福信息聚焦于环保、水利等行业的数字化转型和提升，以AI行业应用为锚点，以环保、水利业务为驱动，构建AI体系化、场景化能力，实现技术和业务的有机融合。',
          btn: 'contact',
        },
      ],
      swiperOption: {
        pagination: '.banner-pagination',
        initialSlide: 0, //默认第几张
        loop: false, //循环
        simulateTouch: false,
        autoplayDisableOnInteraction: false, //触摸后再次自动轮播
        autoplay: 2000, //每张播放时长3秒，自动播放
        speed: 1000, //滑动速度
      },
      //解决方案
      solutionActive: 0,
      solutionData: [
        {
          name: '水环境',
          children: [
            {
              name: '水环境综合管理平台',
              content:
                '以改善区域水生态环境质量为核心，以全面支撑水环境质量持续改善目标。充分运用物联网、视觉AI、数据智能等智能技术手段，集成整合区域水环境数据资源，围绕重点断面水质考核、功能区水质达标、跨界断面考核、流域生态补偿、水污染溯源分析、水环境整治等核心主题形成大数据分析能力，全面支撑水环境质量持续改善管理目标的实现。',
              path: '/solutions/szyzhgl',
            },
            {
              name: '河湖“四乱”综合整治',
              content:
                '利用视觉AI技术有效提取河道、湖泊等水环境要素特征，智能识别“乱建”、“乱占”、“乱堆”、“乱采”四乱问题并联动取证，实现无人值守全天候监控预警。具备水域岸线违章检测、河道漂浮物检测、倾倒垃圾监测、非法采砂船识别等多种涉水对象检测-识别-分类能力，构建以视图为核心的“发现问题-问题取证-派发处置-治理成效分析”全链式在线管理体系，服务河湖长制。',
              path: '/solutions/hhslzl',
            },
            {
              name: '城市污水管网智慧监管',
              content:
                '通过对排水管网液位、流速、流量、水质、浓度等指标进行监测，及时发现并解决雨水混入污水、污水偷排、错排、漏排、管网破损淤堵及城市内涝等问题。实现对管网液位、管网流量、管网有害气体、管网水质等数据采集，实时掌握污水管网运行状况，为污水管网的运行调度、养护管理、快速响应提供有效的数据支持，以便于管理者掌握管网实际状况，能正确部署紧急情况下的应急措施，不断提高污水管网的运行管理水平。',
              path: '/solutions/wsgwzhjg',
            },
            {
              name: '农村生活污水智慧监管',
              content:
                '在农村污水处理站点上加装智能互联设备，实现对站点的运行工况监测、进出水(水量、水质)监测、现场环境监测，增强站点的智能化能力，使之具有远程管理的功能。通过电子工牌、手机定位以及现场视频佐证等多种方式，对站点运维服务人员的到岗情况、到岗时长、运维质量等进行在线监控，确保运维人员按时到岗、足时工作、规范维护。实现所有站点、管线的基础信息、档案、资产等均可在平台地图上快速访问，对站点运行的工况、负荷、能耗、进出水水质、故障可快速进行调度处理，助力农村生活污水处理设施稳定运行。',
              path: '/solutions/ncwszhjg',
           },
           {
              name: '海洋环境综合管理平台',
              content:
                '以改善区域海洋生态环境质量为核心，综合运用卫星遥感、无人机、视频监控、海上自动浮标站等空天地海智能感知手段，实现重点直排海污染源污水和尾水排放监测、入海排污口分类整治、海漂垃圾智慧监管、“美丽海湾”精细化单元管控和全天候可视化监管，全面支撑重点海域污染防治攻坚战，强化陆域海域污染协同治理，打好海洋环境综合管理平台攻坚战，推进“美丽海湾”保护与建设。',
              path: '/solutions/hpljzl',
           },
          ],
        },
        {
          name: '水工程',
          children: [
            {
              name: '智慧水库管理系统',
              content:
                '智慧水库管理系统以“天天安全、百分之百安全”的目标要求，紧紧围绕水库安全管理的各项工作，利用物联网、云计算、大数据、人工智能、三维仿真、水利专业模型等跨学科现代先进技术，搭建区域水库综合管理平台，为水库管理的“三个责任人”提供档案数据归整、巡查自动记录、水工情智能监测、数据智能模拟、报告自动生成和问题闭环管理等服务。为落实“三个重点环节”提供数据支撑和应用服务，为水库的安全运行提供信息化管理手段。对水库水位、雨量、生态下泄流量进行远程监测和监管，确保水库洪涝灾害的预防和下游生态环境的和谐发展。',
              path: '/solutions/zhskgl',
            },
            {
              name: '灌区信息化系统',
              content:
                '灌区信息化系统通过在总干渠及干渠补充建设量测水监测设施、视频监视设备以及闸门控制设备，建立健全完善的通信传输体系以及供电体系，实现总干渠及干渠的信息采集自动化、通信传输网络化；通过在水利局建设灌区数据中心、应用支撑系统，实现灌区数据管理规范化、预警预报模型化；开发灌区管控一张图、闸门监控系统、视频监视系统、水量调度管理系统、综合信息监测管理系统、水量计量与水费计收管理系统、工程运维管理系统以及综合办公管理系统，实现灌区决策分析智能化。灌区信息化系统充分发挥灌溉效益，提高灌溉水利用系数，为灌区水资源的优化配置、高效利用、调度运行提供决策支持，同时变被动服务为主动服务，吸引公众参与。',
              path: '/solutions/gqxxhgl',
            },
          ],
        },
        {
          name: '水资源',
          children: [
            // {
            //   name: '水资源综合调度管理平台',
            //   content:
            //     '待定',
            //   path: '/solutions/szyzhgl',
            // },
            {
              name: '城乡供水一体化',
              content:
                '利用云计算、大数据、物联网技术构建城乡供水一体化解决方案，实现厂站供水、排水、用水用户、水管监测设备数据融合，全面提升城市供水安全、生产管理、监控调度、管网管理、表务管理、决策分析能力，保障城乡供水安全、节水效率和服务质量。',
              path: '/solutions/cxgsyth',
            }
          ],
        },
        {
          name: '企业环保',
          children: [
            {
              name: '固体废物和危险化学品管理',
              content:
                '通过对危险废物经营单位和重点危险废物产生单位布设视频监控和危险废物智能化设备，加强对危险废物的全过程监管，摸清危险废物产生、贮存、转移、利用处置情况，通过智能算法及时发现异常，并进行预警、视频取证，以实现“主动发现、主动取证、主动核查、主动执法”的全过程监管闭环，实现危险废物智能化、实时化、集成化监控，全面提升危险废物过程信息化监管水平，有效防范环境风险隐患。',
              path: '/solutions/gwfqlc',
            }
          ],
        },
      ],
      // 产品矩阵
      matrixData: [
        {
          name: '',
          imgUrl: '/img/bg_title05.png',
          children: [
            {
              name: '<p>VIMS</p>视频智能管理系统',
              path: '/pro_zhwl/spzngl'
            }
          ],
        },
        {
          name: '',
          imgUrl: '/img/bg_title06.png',
          children: [
            {
              name: '<p>UMIoT</p>元物联平台',
              path: '/pro_zhwl/ywl',
            },
          ],
        },
        {
          name: '',
          imgUrl: '/img/bg_title07.png',
          children: [
            {
              name: '<p>EAIGo</p>视频智能分析系统',
              path: '/pro_zhwl/spznfx'
            },
          ],
        },
        // {
        //   name: '',
        //   imgUrl: '/img/bg_title08.png',
        //   children: [
        //     {
        //       name: '<p>EAI</p>智算精灵',
        //       path: '/products/spzngl'
        //     },
        //   ],
        // },
      ],
      // 硬件产品
      hardwareOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        initialSlide: 0, //默认第几张
        slidesPerView: 4.2,
        spaceBetween: 24,
        loop: false, //循环
        simulateTouch: true,
        autoplayDisableOnInteraction: false, //触摸后再次自动轮播
        autoplay: 2000, //每张播放时长3秒，自动播放
        speed: 1000, //滑动速度
      },
      hardwareData: [
        {
          name: 'EAI智算精灵',
          content:
            'EAI智算精灵，是针对生态环保、水利水务等行业的边缘侧智能视频分析盒，产品可以支持水环境漂浮物识别、船只识别、特定区域人员检测、违章建筑、固废物品、料口识别、开关门检测、特种车辆识别、烟火检测、生物多样性识别等30多种高精度深度学习算法。</p><p>EAI智能精灵，可接入1~8路视频监控摄像机，支持实时视频分析、轮巡视频分析多种模式，可以实现监测对象的实时分析，检测的事件图片和视频片段上传到万福EAIGO AI能力平台，进而将检测的事件信息推送到生态环保、水利水务等业务管理系统进行研判。</p><p>EAI智能精灵,通过万福EAIGO AI能力平台，实现检测任务、算法模型和设备运维管理，每个设备可以配置特定的视频通道数量、通道检测类型和分析模式，支持算法模型在线自动更新，通过业务场景数据的累积，不断提升算法模型的精度，适配新的监测对象和事件。</p><p>利用EAI智算精灵，将监管部门关注的重点事件信息上传视频管理平台并长期保存，节约视频传输带宽和后台存储成本，同时结合业务系统对高价值视频事件信息进行二次分析研判，发现异常进行预警，提升非现场监管能力，实现事前布防、 预判，事中现场可视、集中指挥调度，事后可追溯、取证等业务优势。',
          imgUrl: '/img/hardware/img_box01.png',
          path: '/hardware/zsjl',
        },
        {
          name: '水利一杆通WF-JC100',
          content:
            '万福水利一杆通解决方案，高度集成传感监测、视频监控、公共服务、一体化设备箱等水利要素。采集、网络传输和电源系统，匹配水文、视频站点全场景需求，广泛应用于水库、河道、流域等多场景监测站点部署。方案采用模块化集成设计、支持多种传输模式、锂电新储能和统一智能网管系统，使水利监测站点部署更简单、性能更可靠、管理更智能。',
          imgUrl: '/img/hardware/img_box02.png',
          path: '/hardware/slygt',
        },
        {
          name: '存算一体VGIS-N7100',
          content:
            '存算一体VGIS-N7100，基于国产化算力平台实现计算、存储、网络以及统一管理的优化整合，形成软硬一体化产品。 产品在提供高性能计算的同时，还具备超大容量存储和物联扩展能力，为用户提供集成度高、性能优、易维护的计算平台，一站式解决客户数据采集、存储、处理、应用等全生命周期应用需求。',
          imgUrl: '/img/hardware/img_box03.png',
          path: '/hardware/csyt',
        },
        {
          name: '遥测终端机',
          content:
            '遥测终端机是一种用于远程测量、监控和数据传输的设备，广泛应用于工业、能源、环境监测、水利、气象和其他领域，以实现对远程站点的实时监控和数据采集。万福遥测终端机是集水文水资源、视频数据采集和逻辑控制功能于一体的工业级网关型遥测终端机，采用大容量存储和高级路由等新型设计方式，通信网络可采用5G/4G/GPRS等多种无线网络或本地宽带网络将数据传输至中心平台。广泛应用于水文、水资源、智慧排水、智慧供水、智慧农业等综合测控领域。',
          imgUrl: '/img/hardware/img_box04.png',
          path: '/hardware/swyczd',
        },
        {
          name: '多通道振弦采集仪',
          content:
            '万福多通道振弦采集仪，专为振弦型传感器的数据采集设计，精确采集传感器的频率和温度数据。可方便的应用于各种安全监测项目中。例如：水库大坝安全、滑坡防护等。系列产品有单通道WF-ZX01、四通道WF-ZX04、十通道WF-ZX10多个型号，适用于不同不同类型的项目。为了适应现场复杂的安装环境，产品外形结构轻便小巧，满足IP65防护等级要求。',
          imgUrl: '/img/hardware/img_box05.png',
          path: '/hardware/dtdzxcjy',
        },
        {
          name: '雨量计',
          content:
            '全不锈钢雨量计是一种用于测量降水量的设备，用于监测雨水的强度和时长。为降水量测量一次仪表，其性能符合国家标准GB/T21978.2-2014《降水量观测要求》要求。翻斗采用三维流线型设计，全不锈钢材质制作，翻水性能更加流畅，且具有自涤灰尘、容易清洗的功能。',
          imgUrl: '/img/hardware/img_box06.png',
          path: '/hardware/hyetometer',
        },
        {
          name: '气泡式水位计',
          content:
            '气泡式水位计是新一代高精度智能型气泡式水位计，产品执行GB/T11828标准，具有安装方便、高精度、高可靠性及非接触式测量、兼容性高、多种通讯接口等显著优点。本产品通常用于需要简单、经济且可靠的水位测量场合，特别适合中小河流水位监测、大坝上下游水位的测量；海洋、地下水水位的测量;化工、煤矿、污水处理、自来水厂等处的水位及液位的监测;适用于不便建测井或建测井费用昂贵的地区。',
          imgUrl: '/img/hardware/img_box07.png',
          path: '/hardware/qpsswj',
        },
        {
          name: '雷达水位计',
          content:
            '雷达水位计是一种利用雷达技术测量水体水位的设备，通过发射雷达波并测量其反射时间来确定水面的距离，从而实现对水位的准确测量，不受温度、湿度、水中污染物、漂浮物等影响。测量精度高、功耗极低、体积小、安装便捷、免维护，广泛应用于水文测量、水库管理、河流水位监测、洪水预警系统、海洋测量以及工业和环境监测等领域。其非接触性和远距离测量的能力使其适用于各种水体环境。',
          imgUrl: '/img/hardware/img_box08.png',
          path: '/hardware/ldswj',
        },
        {
          name: '振弦式渗压计',
          content:
            '振弦式渗压计是一种测量软土地基深层孔隙水压力的传感器，具有较高的灵敏度和快速的响应时间。广泛应用于:大坝、尾矿库、隧道、路基、边坡等工程中地基深层水压力的测量,从预钻孔埋入至设计待测点。',
          imgUrl: '/img/hardware/img_box09.png',
          path: '/hardware/zxssyj',
        },
        {
          name: '磁致式量水堰计',
          content:
            '磁致式量水堰计是一种利用磁致伸缩效应来测量水位或水位变化的设备，具有测量精度高、抗干扰能力强、使用寿命长等优势。由于没有直接与水接触的机械部件，因此具有较好的耐腐蚀性能，适用于恶劣的环境条件。可以广泛应用于水文测量、河流水位监测、水库水位管理、洪水预警系统、海洋测量等领域。其稳定性和精确性使其成为水文学和水资源管理中重要的测量工具。',
          imgUrl: '/img/hardware/img_box10.png',
          path: '/hardware/czslsyj',
        },
        {
          name: '流量计',
          content:
            '多普勒雷达流量计是一种非接触的测试设备，集成了微带天线、射频电路、及信号处理模块，可直接获取流体表面流速信息。流速雷达通过水体表面波移动形成的多普勒效应来进行测量。建议流速传感器模块安装面朝向上游，水流速度靠近流速传感器模块，速度显示正速度。雷达发射方向如果有水、金属等反射较强的遮挡物，会严重影响雷达测试效果。水位雷达则可以获取水位的数据，结合基底数据就可以推算出过水面积，与流速数据相乘就可以获得流量数据。产品可以广泛应用于水文、水利、环保、水务等部门在江、河、渠道等流速与流量测量。',
          imgUrl: '/img/hardware/img_box13.png',
          path: '/hardware/flowmeter',
        },
        {
          name: '表面变形监测',
          content:
            '一款专业适用于高精度地表位移及沉降监测的普适型GNSS监测接收机,其采用最新高精度芯片,内置MEMS传感器,支持 MEMS联动及自动触发加密观测,结合先进前端算法,具有精度高、集成度高,防护等级高,性价比高,以及功耗低、安装难度低、WebUI 智能操作以及处理性能强大等特点,其支持前端边缘计算,基于Linux智能系统,支持智能化远程运维,运维成本低,智能化程度高,可完全满足各类型监测工程(地灾矿山、水利、大坝、边坡等),以及便捷型监测基站建设等需求,适应于野外环境下的长时间监测。',
          imgUrl: '/img/hardware/img_box14.png',
          path: '/hardware/bmbxjc',
        }
      ],

      // 项目案例
      casesIndex: 0,
      caseData: [
        {
          name: '水环境',
          children: [
            {
              name: '罗源南门溪、起步溪水环境综合整治项目',
              content:
                '罗源南溪、起步溪水环境综合整治项目以改善罗源县水环境质量为核心，按照“治理整体化、截污最大化、两岸景观化、沿岸生态化、管理制度化”的建设精神，确保本区域资源开发与防洪、水利、环境功能综合协调。开展流域内主要断面水质监测分析和预警工作，对流域沿线工业企业、农业面源、水产养殖、畜禽养殖、牛蛙养殖污染状况、农村生活污水治理情况等各类排口精准摸排，形成问题清单；通过“数字治水”有效监督和解决“乱占”、“乱采”、“乱堆”、“乱建”的“四乱”问题，最终实现各级各部门信息共享，将每个环节的责任落实到具体单位和具体责任人，实现综合执法工作联动。项目用新技术、新机制落实河长制，最大限度地发挥其环境效益、社会效益及经济效益，实现水长清、岸长绿、河长治。',
              imgUrl: '/img/bg_card02.png',
              path: '/caseDetail/lynmx',
            },
            {
              name: '海南省定安县城乡污水治理项目',
              content:
                '本项目涉及定安县黄竹、龙湖、龙门、翰林等4个建制镇及其下辖的35个行政村(共计343个自然村)，覆盖面积5260K㎡，建成运行后将服务当地115695人，可削减污染物排放量:污水量1663m³/d，CODcr约260吨/年，氨氨约20吨/年。对实现定安县黄竹、龙湖、龙门、翰林4个地区的乡村振兴有着深远意义。',
              imgUrl: '/img/bg_card03.png',
              path: '/caseDetail/hnsdaxwszl',
            },
            {
              name: '仙游县农村生活污水提升治理智慧监管项目',
              content:
                '根据《福建省农村生活污水提升治理五年行动计划（2021-2025）》（闽政办[2021]28号）、《福建省生态环境厅关于开展农村生活污水提升治理智慧监管试点工作的通知》，开展仙游县农村生活污水提升治理智慧监管试点工作，对仙游县已安装大量农村生活污水处理设施，统一规划、分步实施，选择部分示范点对农村生活污水处理设施开展综合运维监管，对示范点的农村生活污水处理运维设施均通过管理平台实现智能化管理。',
              imgUrl: '/img/bg_card01.png',
              path: '/caseDetail/xyncshws',
            },
          ],
        },
        {
          name: '水工程',
          children: [
            {
              name: '德化县小型水库雨水情测报和大坝安全监测项目',
              content:
                '德化县位于福建省中部、泉州市北部，全县小（二）型以上水库59座，总库容3.17亿立方米。项目以“向科技要人力、以创新激活力”为原则，持续探索科学的管理体制和模式，对县内湖库进行统一规划，安装智慧水库系统，实现湖库管理信息化、智能化，推动湖库高质量管护，更好地保障湖库安全；运用人工智能技术对水库的违章建筑、人员垂钓、下水游泳等行为进行自动识别和联动告警，联动广播音柱实现自动喊话，有效防治上述行为，大大提升了湖库的管护效率；通过系统连续监测，水库雨水情、大坝安全等特征要素实现自动测报，管理人员使用电脑或手机端即可实时掌握水库运行情况，为水库的日常治理、护航自然灾害和极端天气下的水库安全管理发挥重要作用。2022年11月，德化县“科技赋能，保一方湖库平安”的先进案例也得到了央视网关注和报道。',
              imgUrl: '/img/bg_card01.png',
              path: '/caseDetail/dhsk',
            },
            {
              name: '漳浦县水库雨水情和安全设施监测系统',
              content:
                '本项目建设以“统一规划、上下连接，讲求效益、注重应用”为原则，以水库雨水情和大坝安全监测物联网+视频AI算法智能分析管控为目标，基于现有设施资源的基础上，按照水利设施感知信息完善化、精细化、智能化的管理思路，让监管人员对水库的雨水情和安全监测监管，实现远程化监管应用，可视化决策分析。',
              imgUrl: '/img/bg_card02.png',
              path: '/caseDetail/zpxsk',
            },
          ],
        },
        {
          name: '水资源',
          children: [
            {
              name: '泉州市水资源综合调度平台-智慧水利一期',
              content:
                '泉州市水资源综合调度平台-智慧水利一期充分运用云计算、物联网、大数据、移动互联网、人工智能等新一代信息技术，建设泉州市智慧水利平台。平台通过强化水资源调度与小流域山洪灾害预报预警模型算法，实现泉州水资源“多源互补、丰枯调剂、环境优美”的科学联合调度目标。泉州市水资源综合调度平台累计汇聚了1500多个水利设施基础信息，包括水库、水闸、提防、泵站、引水工程、水电站等，同时接入了900多个气象、水文、预警、山洪的实时监测站点，累积采集了4000万多的实时监测数据，为泉州市智慧水利的建设奠定坚实的基础，有效助力了泉州“上蓄下引、河库连通”的水网工程体系建设。',
              imgUrl: '/img/bg_card01.png',
              path: '/caseDetail/qzzhsl',
            },
          ],
        },
        {
          name: '企业环保',
          children: [
            {
              name: '福建省危险废物智能化系统项目',
              content:
                '本项目依托省生态云视频能力平台、融合生态云-福建省固体废物环境信息化监管系统，将358家重点监管企业纳入智能化监管，并根据企业情况配备视频监控、智能管理终端等设备。通过视频AI智能算法，及时发现异常，并进行预警，预防苗头性环境问题，提升危险废物智能化监管水平。充分应用物联网技术，对福建省内危险废物经营单位和重点危险废物产生单位配备智能电子秤过磅，打印危险废物二维码标签，做到一袋一码，实现从危废称重、标签、出入库、申报到转移等全流程的业务自动化，同时将业务数据自动推送至生态云-福建省固体废物环境信息化监管系统。',
              imgUrl: '/img/bg_card03.png',
              path: '/caseDetail/fjswxfw',
            },
          ],
        },
        {
          name: '核心能力',
          children: [
            {
              name: '福建省“生态云“视频能力平台',
              content:
                '福建省生态云平台是针对生态环境部门管理人员用户，通过环保专网登入的监管应用平台，是一个大平台、大数据、大系统的云平台，是形成分析决策指挥一张图的平台。生态云视频能力平台累计接入全省1万多路生态环境相关视频资源，包括涉疫医疗单位、涉疫医疗废物处置单位、饮用水源地、固定污染源、国控断面、大气监测、废铅蓄电池收集企业、污染地块监测、固废-危废-经营单位、海漂垃圾监测、核辐射等 10 多个环保专题的 100多种监控部位。平台曾多次获得中央深改委、国务院办公厅、生态环境部等刊文、表扬和转发，由视频能力平台提供核心能力的《创新建立海漂垃圾综合治理长效机制 坚决守护碧海银滩》荣获福建省第四届“推进机制活、建设新福建”全省机关体制机制创新优秀案例“一等奖”。',
              imgUrl: '/img/bg_card03.png',
              path: '/caseDetail/fjswxfw',
            },
            {
              name: '水利视频AI示范应用',
              content:
                '利用视频AI技术有效提取河道、湖泊、水库等水环境要素特征，识别违规行为并取证，实现无人值守全天候监控预警。研发了水葫芦识别、河道漂浮物检测、水域岸线违章检测、非法采砂船识别等10多种涉水对象检测-识别-分类能力，构建以视图为核心的水利全链式在线管理体系。',
              imgUrl: '/img/bg_card01.png',
              path: '/caseDetail/slspaisf',
            },
            {
              name: '莆田市“全域数字化全市一张图”视频服务平台',
              content:
                '莆田市“全域数字化，全市一张图”统筹运用数字化技术、思维、能力，搭建大数据调度指挥平台，把数字化贯彻到莆田经济、政治、文化、社会、生态文明建设全过程各方面，对市域治理的模式进行全方位、系统性重塑，做到精准、科学、依法、高效，全面提升社会治理体系和治理能力现代。相关工作纳入了《2022 年数字福建工作要点》。其中，视频服务平台首创了城市级、多租户视频资源标签治理体系，与莆田市政务 0A 系统打通，实现申请、审批、调阅、共享全程留痕，助力政府视频安全、有序地共享。累计接入全市各部门 15多万路视频，实现跨部门视频共享共9万多路，累计开展视频标签治理 20多万次，形成标签数据3万多条，支撑了防汛防台风、木兰溪综合治理、防疫物资“一张图”、“党建引领、夯基惠民”、五联防“一张图”等专题应用。',
              imgUrl: '/img/bg_card02.png',
              path: '/caseDetail/ptsyzt',
            },
          ],
        },
      ],
      // 快捷部署
      deployData: [
        {
          name: 500,
          unit: '+',
          content: '合作客户',
        },
        {
          name: 20,
          unit: '+',
          content: '行业覆盖',
        },
        {
          name: 1000,
          unit: '+',
          content: '应用场景',
        },
        {
          name: 200,
          unit: '万+',
          content: '样本数量',
        },
      ],
      // 新闻咨询
      newsData: [
        {
          name: '央视网 | 福建德化：科技赋能 保一方湖库平安',
          content:
            '今年来，福建省德化县高度重视河流湖库保护管理工作，深化湖长制。福建万福信息技术有限公司凭借扎实的人工智能技术以及丰富的水利行业AIoT建设经验，运用EAI智算精灵等产品，协助德化县水利局建设水库雨水情测报、大坝安全监测等设施，健全湖库安全运行监测系统，助力提升湖库智能化管理水平，获央视网报道认可。',
          date: '2022-12-30',
          imgUrl: '/img/news.png',
          path: '',
        },
        {
          name: '千淘万漉虽辛苦 吹尽黄沙始到金-------2023新年贺词',
          content:
            '回首即将阔别的旧岁，道阻且难。疫情三年，从地方政府，到每个行业直至每个公司都经历了史无前例的大考。从年初满怀期望与憧憬，直至面对各种焦虑与无奈，我们在一次次失望中又一次次燃起希望。',
          date: '2022-12-31',
          imgUrl: '/img/news.png',
          path: '',
        },
        {
          name: '万福视频智能管理系统（VIMS）通过公安部产品质量检测认证',
          content:
            '万福视频智能管理系统（VIMS）通过国家安全防范报警系统产品质量检验检测中心、公安部安全与警用电子产品质量检测中心认证',
          date: '2022-10-31',
          imgUrl: '/img/news.png',
          path: '',
        },
        {
          name: '2022年中工作总结会及团建活动',
          content:
            '时光流转，岁月的脚步不停，2022年已然过半。为总结公司上半年经营情况，全面理清下半年工作思路，进一步动员全体员工振奋工作精神，盯住全年目标任务，敬业拼搏，保质保量完成全年业绩目标，我公司于8月20日举办了2022年年中工作总结会。',
          date: '2022-08-23',
          imgUrl: '/img/news.png',
          path: '',
        },
      ],
    }
  },
  watch: {
    currentModule(newV) {
      if (newV == 5) {
        setTimeout(() => {
          this.deployData.map((item, ind) => {
            this.animationNum(ind)
          })
        }, 600)
      }
    },
  },
  mounted(){
    let query = this.$route.query
    if(query&&query.solutionActive!=undefined){
      this.solutionActive = query.solutionActive
      let solutionModuleRef = this.$refs.solutionModule.$el
      solutionModuleRef.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      
    }
    // console.log(,'33333');
  },
  methods: {
    swiperEnter,
    swiperLeave,
    jumpTo,
    tabLeave,
    // 计算解决方案宽度
    solutionItemSty(i){
      let wid = 450;
      let hei = 260;
      let itemLength = this.solutionData[this.solutionActive].children.length
      if(itemLength==1){
        wid = wid*2
        hei = hei*2
      }else if(itemLength==2||(itemLength%2==1&&i+1==itemLength)){ // 只有两个，或者奇数个的最后一个时
        wid = wid*2
      }
      return {
        width: wid+'px',
        height: hei+ 'px'
      }
    },
    animationNum(ind) {
      let num = this.deployData[ind].name
      this.deployData[ind].name = 0
      gsap.to(this.deployData[ind], {
        duration: 2,
        name: Number(num) || 0,
      })
    },
    caseEnter(index){
      if (this.casesIndex == index) return
      if (this.timer) clearTimeout(this.timer)
      this.tabEnterTime = new Date().getTime()
      this.timer = setTimeout(() => {
        this.casesIndex = index
        const tl2 = gsap.timeline()
        this.$nextTick(()=>{
          tl2.staggerFromTo('.case-item',.3,{
            opacity:0,
            x:300,
            ease:"back.in(1.7)",
          },{
            opacity:1,
            x:0,
            ease:"back.in(1.7)",
          },.2,'+=0')
        })
      }, 350);
    },
    solutionEnter(ind){
      if (this.solutionActive == ind) return
      if (this.timer) clearTimeout(this.timer)
      this.tabEnterTime = new Date().getTime()
      this.timer = setTimeout(() => {
        this.solutionActive = ind
        const tl2 = gsap.timeline()
        this.$nextTick(()=>{
          tl2.staggerFromTo('.solution-item',.3,{
            opacity:0,
            scale: 0.7,
            ease:"back.in(1.7)",
          },{
            opacity:1,
            scale: 1,
            ease:"back.in(1.7)",
          },.1,'+=0')
        })
      }, 350);
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util.scss';
.banner-swiper {
  height: 872px;
  width: 100%;
  .swiper-img {
    height: 100%;
    background: rgb(20, 27, 35);
    @include bgConfig;
    .content {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      color: #ffffff;
      .title {
        font-size: 40px;
      }
      .line {
        width: 80px;
        height: 2px;
        background: #ffffff;
        margin-top: 40px;
      }
      .desc {
        font-size: 16px;
        width: 448px;
        line-height: 30px;
        letter-spacing: 1px;
        margin: 30px 0 40px;
      }
    }
  }
}
.intro-slot {
  padding: 24px;
  min-height: 300px;
  display: flex;
  background: #fff;
  border-radius: 4px;
  .intro-text {
    margin-left: 56px;
    ::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
  }
  .intro-top {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    font-weight: bold;
    margin: 24px 0;
    color: #333333;
    letter-spacing: 1.5px;
    align-items: center;
    letter-spacing: 1.07px;
    .intro-more {
      font-size: 20px;
      cursor: pointer;
      &:hover {
        color: #0b68bf;
      }
    }
  }
  .intro-bottom {
    padding-right: 3px;
    overflow-y: scroll;
    color: #666666;
    font-size: 20px;
    line-height: 40px;
    text-indent: 2em;
    text-align: justify;
  }
}
.solution-slot {
  display: flex;
  width: 100%;
  min-height: 520px;
  border-radius: 8px 4px 4px 8px;
  background: #ffffff;
  color: #333333;
  .solution-menu {
    width: 300px;
    padding: 32px 0;
    flex-shrink: 0;
    @include bgConfig;
    background-size: 100% 100%;
    background-image: url('../../public/img/bg02.png');
    position: relative;
    li {
      display: flex;
      align-items: center;
      font-size: 20px; 
      padding: 0 28px;
      height: 80px;
      cursor: pointer;
      &.line{
        position: absolute;
        top: 32px;
        left: 0;
        content: '';
        width: 6px;
        padding: 0;
        height: 80px;
        background: #0b68bf;
        transition: all .2s linear;
      }
      &.active {
        color: #0b68bf;
        background: linear-gradient(90deg, #ffffff, rgba(255, 255, 255, 0));
      }
    }
  }
  .solution-content {
    display: flex;
    flex-wrap: wrap;
    .solution-item {
      width: 450px;
      height: 260px;
      padding: 32px 40px;
      background: #fff;
      font-size: 16px;
      border-right: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
      transition: all .3s linear;
      &:hover{
        position: relative;
        z-index: 100;
        box-shadow: 0 8px 20px rgb(0 0 0 / 10%);
      }
      // &:nth-child(2) {
      //   border-right: none;
      // }
      // &:nth-child(3) {
      //   border-bottom: none;
      // }
      // &:nth-child(4) {
      //   border-right: none;
      //   border-bottom: none;
      // }
      .item-name {
        font-weight: bold;
        font-size: 24px;
      }
      .item-content {
        margin-top: 30px;
        margin-bottom: 40px;
        line-height: 26px;
        @include text-ellipsis-line(3);
      }
    }
  }
}
.matrix-slot {
  width: 100%;
  min-height: 267px;
  border-top: 1px solid #929caa;
  padding-top: 30px;
  .matrix-wrap{
    display: flex;
    justify-content: space-between;
  }
  .matrix-item {
    flex: 1;
    margin-right: 24px;
    color: #fff;
    background-color: rgba($color: #16202c, $alpha: 0.7);
    &:last-child{
      margin-right: 0;
    }
    .matrix-title {
      height: 104px;
      font-size: 24px;
      // font-weight: bold;
      @include text-center;
      @include bgConfig;
      letter-spacing: 1.29px;
      background-size: 100% 100%;
    }
    .item-name {
      // cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-weight: bold;
      text-align: center;
      min-height: 216px;
      line-height: 33px;
      font-size: 24px;
      cursor: pointer;
      transition: transform .3s linear;
      // border-bottom: 1px solid rgba($color: #929caa, $alpha: 0.2);
      &:nth-child(6) {
        border-bottom: none;
      }
      &:hover {
        color: #9edcff;
        font-weight: bold;
        transform: scale(1.02);
        box-shadow: 0 2px 6px rgb(0 0 0 / 11%);
        background: linear-gradient(270deg, rgba(11, 104, 191, 0.2), #0b68bf);
      }
      // &::before {
      //   content: '';
      //   width: 6px;
      //   height: 6px;
      //   margin-right: 8px;
      //   background: linear-gradient(180deg, #ffffff, #48aafb);
      //   border-radius: 50%;
      // }
    }
  }
}
.hardware-wrap{
  padding-bottom: 128px;
  overflow: hidden;
}
.hardware-slot{
  width: 100%;
  min-height: 470px;
  overflow: hidden;
  .hardware-swiper{
    overflow: visible;
    .swiper-pagination{
      bottom: -35px;
    }
  }
  ::v-deep .swiper-pagination-bullet{
    width: 40px;
    height: 6px;
    border-radius: 0;
    background: #595959;
    &.swiper-pagination-bullet-active{
      background: #0b68bf;
    }
  }
  .hardware-item {
    // width: 320px;
    height: 430px;
    background: #fff;
    padding: 24px 32px;
    overflow: hidden;
    position: relative;
    color: #333333;
    @include hoverTrans;
    .hardware-img {
      width: 180px;
      height: 150px;
      margin: 0 auto;
      @include bgConfig;
      background-size: contain;
      background-position: center;
      margin-bottom: 16px;
    }
    .title {
      font-size: 20px;
      width: 100%;
      margin: 26px auto 12px;
      @include text-ellipsis-line(1);
      font-weight: bold;
    }
    .desc {
      width: 100%;
      opacity: 0.7;
      font-size: 16px;
      @include text-ellipsis-line(3);
      line-height: 30px;
      letter-spacing: 0.02px;
    }
    .item-btn {
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.case-wrap{
  padding-bottom: 56px;
}
.case-slot {
  width: 100%;
  min-height: 455px;
  color: #333333;
  .case-menu {
    position: relative;
    display: flex;
    border-bottom: 1px solid rgba($color: #929caa, $alpha: 0.4);
    .case-tab {
      font-size: 18px;
      width: 33.3%;
      height: 50px;
      cursor: pointer;
      text-align: center;
      &.active {
        font-weight: bold;
        color: #0b68bf;
      }
    }
    .line {
      position: absolute;
      width: 72px;
      height: 3px;
      left: 0;
      transition: all 0.2s linear;
      transform: translate(-50%);
      background: #0b68bf;
      bottom: 0;
    }
  }
  .target-content {
    display: flex;
    flex-wrap: wrap;
    padding-top: 64px;
    .case-item {
      position: relative;
      @include bgConfig;
      background-size: 100% 100%;
      box-shadow: 0px 4px 20px 0px rgba(227, 233, 239, 0.5);
      width: 384px;
      height: 340px;
      margin-right: 24px;
      margin-bottom: 24px;
      font-size: 18px;
      border-radius: 4px;
      padding: 32px 40px;
      top: 0px;
      transition: all .3s linear;
      &:nth-child(3n){
        margin-right: 0;
      }
      &:hover{
        top: -10px;
        box-shadow: 0 2px 6px rgb(0 0 0 / 11%);
      }
      .case-name {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 40px;
        @include text-ellipsis-line(1);
      }
      .case-content {
        font-size: 16px;
        line-height: 30px;
        letter-spacing: 0.02px;
        @include text-ellipsis-line(5);
      }
      .item-btn {
        position: absolute;
        bottom: 32px;
      }
    }
  }
}
.deploy-slot {
  width: 100%;  
  min-height: 117px;
  margin: 80px auto 120px;
  .deploy-wrap{
    display: flex;
    justify-content: space-between;
  }
  .deploy-item {
    text-align: left;
    .item-top {
      font-size: 64px;
      font-weight: 700;
      color: #ffffff;
      line-height: 74px;
      letter-spacing: 2.67px;
      margin-bottom: 12px;
    }
    .item-bottom {
      font-size: 24px;
      color: #b7bfc9;
    }
  }
}
.news-slot {
  width: 100%;
  min-height: 422px;
  display: flex;
  color: #333333;
  justify-content: space-between;
  font-size: 14px;
  .news-left {
    width: 480px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 4px 15px 0px rgba(236, 239, 244, 0.5);
    transition: transform .2s linear;
    overflow: hidden;
    &:hover{
      box-shadow: 0 2px 6px rgb(0 0 0 / 11%);
      transform: scale(1.02);
      .news-img{
        background-size: 105% 105%;
      }
    }
    .news-img {
      height: 284px;
      width: 100%;
      @include bgConfig;
      transition: all .3s linear;
      background-size: 100% 100%;
    }
    .left-content {
      padding: 16px;
      .con-bottom {
        display: flex;
        justify-content: space-between;
        span {
          color: #929caa;
        }
      }
    }
  }
  .con-top {
    font-weight: bold;
    font-size: 16px;
  }
  .content {
    color: #666666;
    line-height: 20px;
    margin: 8px auto;
    @include text-ellipsis-line(2);
  }
  .item-btn {
    font-size: 14px;
  }
  .news-right {
    width: 696px;
    .news-item {
      display: flex;
      width: 100%;
      height: 130px;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0px 4px 10px 0px rgba(236, 239, 244, 0.5);
      padding: 16px 20px 16px 0;
      margin-bottom: 16px;
      transition: transform .3s linear;
      &:hover{
        box-shadow: 0 2px 6px rgb(0 0 0 / 11%);
        transform: scale(1.02);
      }
      &:last-child {
        margin-bottom: 0;
      }
      .item-left {
        width: 100px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        margin-right: 24px;
        .left-wrap {
          width: 100%;
          text-align: center;
        }
        .left-top {
          font-weight: bold;
        }
        .left-bottom {
          font-weight: bold;
          color: #0b68bf;
          line-height: 40px;
          font-size: 32px;
        }
        &::after {
          content: '';
          display: inline-block;
          width: 1px;
          height: 40px;
          background: #d8d8d8;
        }
      }
    }
  }
}
</style>